import { createTheme } from '@material-ui/core';

export const themeMobimoProd = createTheme({
	palette: {
		primary: {
			main: '#F58441',
		},
		secondary: {
			main: '#FF9F66',
		},
		background: {
			default: '#F58441',
		},
	},
});
